(function () {
  "use strict";

  // QuickViewDrawer is defined as an anonymous class expression inside
  // customElements.define, so it isn't a global — get it from the registry once the
  // base has registered (both scripts are deferred and load in order).
  customElements.whenDefined("quick-view-drawer").then(function () {
    if (customElements.get("custom-bundle-quickview")) return;
    var QuickViewDrawer = customElements.get("quick-view-drawer");

    class CustomBundleQuickView extends QuickViewDrawer {
      connectedCallback() {
        super.connectedCallback();
        // Unique per instance so the base's replaceAll(sectionId, this.selector) in
        // renderProduct can't collide between two bundle drawers on one page.
        this.selector = "custombundle-qv-" + (this.dataset.sectionId || this.id);
        this.addEventListener("click", this.onBundleCtaClick.bind(this));
      }

      open(opener) {
        this.openerCard = opener.closest(".card-product");
        this.cardTrigger = this.openerCard
          ? this.openerCard.querySelector(".js-add-to-bundle")
          : null;
        this.owner = opener.closest("custom-bundle");
        super.open(opener);
        // Reveal is scoped to this element (not the shared body-class) so a second
        // bundle section's drawer isn't slid in at the same time — its empty,
        // spinner-only panel would otherwise cover this one's content.
        this.classList.add("is-open");
      }

      close() {
        super.close();
        this.classList.remove("is-open");
        if (this._resolveAbort) {
          this._resolveAbort.abort();
          this._resolveAbort = null;
        }
        this.openerCard = null;
        this.cardTrigger = null;
        this.owner = null;
        this._resolved = null;
      }

      // Bundle mode has no product-form; emit the localized CTA from the shell's
      // <template>. With no product-form, the base renderProduct always takes the
      // full-rebuild branch, so this runs on every variant change.
      getProductFormHtml() {
        var tpl = this.querySelector(".js-custom-bundle-quickview-cta-template");
        return tpl ? tpl.innerHTML : "";
      }

      // Variant-change hook: the picker short-circuits inside the drawer and never
      // fires productVariantChange, so re-sync the CTA after every render.
      renderProduct(html, variant) {
        super.renderProduct(html, variant);
        this.syncBundleCta();
      }

      syncBundleCta() {
        if (!this.owner) return;
        var cta = this.querySelector(".js-custom-bundle-quickview-add");
        if (!cta) return;
        var picker = this.querySelector("variant-selects, variant-radios");
        var ids =
          picker && typeof picker.getSelectedOptionValues === "function"
            ? picker.getSelectedOptionValues()
            : [];
        cta.disabled = true;
        if (this._resolveAbort) this._resolveAbort.abort();
        this._resolveAbort = new AbortController();
        var self = this;
        this.owner
          .resolveVariant(this.productUrl, ids, this._resolveAbort.signal)
          .then(function (res) {
            if (!self.isOpen) return;
            var freshCta = self.querySelector(".js-custom-bundle-quickview-add");
            if (!freshCta) return;
            self._resolved = res;
            self.owner.applyVariantState(
              freshCta,
              res.variant,
              res.loginForPrice,
              res.callForPricing,
            );
            self.togglePriceCta(res.callForPricing, res.loginForPrice);
            self.mirrorCardSwatch();
          })
          .catch(function (err) {
            if (err && err.name === "AbortError") return;
            var freshCta = self.querySelector(".js-custom-bundle-quickview-add");
            if (freshCta) self.owner.applyButtonState(freshCta, "unavailable", false);
            self.togglePriceCta(false, false);
          });
      }

      // A login/call-for-pricing variant isn't stageable: applyVariantState hides the bundle
      // button, so reveal the theme's matching affordance in its place (the call-for-pricing
      // link or the login message) — otherwise the button just vanishes into a dead end. The
      // footer is rebuilt from the shell template on every render, so both default to hidden
      // and this re-asserts the right one per resolve.
      togglePriceCta(callForPricing, loginForPrice) {
        var call = this.querySelector(".js-custom-bundle-quickview-call");
        var login = this.querySelector(".js-custom-bundle-quickview-login");
        if (call) call.hidden = !callForPricing;
        if (login) login.hidden = !loginForPrice;
      }

      // Reflect the drawer's selected colour back onto the card swatch + image (matched by
      // option-value-id, which is globally unique). No-op unless the card is an upgraded
      // <product-card>.
      mirrorCardSwatch() {
        var card = this.openerCard;
        if (!card || typeof card.handleColorSwatchClick !== "function") return;
        var swatches = card.querySelectorAll(".card-product-color-swatch");
        if (!swatches.length) return;
        var opts = this.querySelectorAll("select option:checked, fieldset input:checked");
        for (var i = 0; i < opts.length; i += 1) {
          var ovid = opts[i].dataset.optionValueId;
          if (!ovid) continue;
          for (var j = 0; j < swatches.length; j += 1) {
            var sw = swatches[j];
            if (sw.dataset.optionValueId === ovid && !sw.classList.contains("is-active")) {
              card.handleColorSwatchClick(sw);
              break;
            }
          }
        }
      }

      onBundleCtaClick(event) {
        var cta = event.target.closest(".js-custom-bundle-quickview-add");
        if (!cta || !this.owner || !this._resolved) return;
        var variant = this._resolved.variant;
        if (!variant || variant.available === false) return;
        this.owner.stageVariant(this.openerCard, variant, this.cardTrigger);
        this.close();
      }
    }

    customElements.define("custom-bundle-quickview", CustomBundleQuickView);
  });
})();
